module.exports = __webpack_public_path__ + "media/winner.1768de81.mp3";